import * as React from 'react';
import { observer } from 'mobx-react-lite';

interface TariffWrapperProps {
    children: React.ReactNode;
}

export const TariffWrapper: React.FC<TariffWrapperProps> = observer(({ children }) => {
    return (
        <div className="relative flex h-full flex-col gap-medium rounded-xlarge bg-neutral-white bg-[linear-gradient(to_bottom,var(--tariff-background)_0%,rgba(255,255,255,0)_100%)] p-small shadow-strong lg:p-large">
            {children}
        </div>
    );
});
